module.exports = __webpack_public_path__ + "static/CircularXX-Book-b37b4066e32a51477ff1a051f8b6025f.woff";